import { render, staticRenderFns } from "./HeaderLastDocuments.vue?vue&type=template&id=1d71730e&scoped=true"
import script from "./HeaderLastDocuments.vue?vue&type=script&lang=js"
export * from "./HeaderLastDocuments.vue?vue&type=script&lang=js"
import style0 from "./HeaderLastDocuments.vue?vue&type=style&index=0&id=1d71730e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71730e",
  null
  
)

export default component.exports